var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSupportIcon = function SvgSupportIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M10.001 15.833c0-5.523 4.478-10 10-10s10 4.477 10 10v1.118a5 5 0 0 1 3.334 4.715v1.667a5 5 0 0 1-3.364 4.726 5 5 0 0 1-4.136 4.372v.069c0 .92-.747 1.666-1.667 1.666h-5c-.92 0-1.667-.746-1.667-1.666v-1.667c0-.92.746-1.667 1.667-1.667h5c.886 0 1.61.69 1.663 1.563a3.34 3.34 0 0 0 2.399-2.396H27.5a.833.833 0 0 1-.833-.833v-10c0-.46.373-.834.833-.834h.834v-.833a8.333 8.333 0 1 0-16.667 0v.833h.833c.46 0 .834.373.834.834v10c0 .46-.374.833-.834.833h-.833a5 5 0 0 1-5-5v-1.667a5 5 0 0 1 3.333-4.715zm9.167 15h5V32.5h-5z",
    clipRule: "evenodd"
  })));
};
export default SvgSupportIcon;